import { AssetMap } from './AssetMap';
import { SvgProps } from './types';

interface IconProps extends SvgProps {
  name: keyof typeof AssetMap;
}

export const Icon = ({ name, ...props }: IconProps): JSX.Element => {
  return AssetMap[name](props);
};
